export const refs = {
  listFilm: document.querySelector('.listFilm'),
  form: document.querySelector('#search-form'),
  errorMes: document.querySelector('#errorS'),
};
